import React, {Fragment} from "react";
import {useUserProfileImage} from "../../../Hooks/useUserProfileImage";

export const UserNameFieldViewer = (props) => {
	const { Data, Value } = props;
	const userProfileImage = useUserProfileImage(Data);
	
	return (
		<Fragment>
			<div className="sb-account-icon">
				<img src={userProfileImage} alt=""/>
			</div>
			{Value}
		</Fragment>
	);
};
